import { HistoryList } from "../components/History/HistoryList";

export function HistoryPage() {
  return <HistoryList />;
}
